import React from 'react';
import { Phone, Mail, Facebook, Instagram, MapPin, Heart } from 'lucide-react';
import { businessInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#7A8A77] via-[#8B9E8A] to-[#9CAF88] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_equicanine-spa/artifacts/oowyuozl_IMG_2303.png" 
                alt="Gratia Animalis Logo" 
                className="h-12 w-auto"
              />
            </div>
            <h3 className="text-2xl font-bold text-[#C5A572] mb-2">{businessInfo.name}</h3>
            <p className="text-white/80 mb-4">{businessInfo.tagline}</p>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <MapPin size={16} className="text-[#C5A572]" />
              <span>{businessInfo.location}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-[#C5A572] mb-4">Navigation</h4>
            <ul className="space-y-2">
              {['Accueil', 'Services', 'Tarifs', 'Galerie', 'À propos', 'FAQ', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase().replace('à propos', 'about').replace('accueil', 'hero'))}
                    className="text-white/80 hover:text-[#C5A572] transition-colors text-sm"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-[#C5A572] mb-4">Mes Services</h4>
            <ul className="space-y-2 text-white/80 text-sm">
              <li>🐴 Massage Équin</li>
              <li>🐕 Massage Canin</li>
              <li>Préparation à l'effort</li>
              <li>Récupération sportive</li>
              <li>Enveloppement aux algues</li>
              <li>Forfaits personnalisés</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-[#C5A572] mb-4">Contact</h4>
            <div className="space-y-3">
              <a 
                href={`tel:${businessInfo.phone}`}
                className="flex items-center gap-3 text-white/80 hover:text-[#C5A572] transition-colors group"
              >
                <div className="bg-white/10 p-2 rounded-full group-hover:bg-[#C5A572]/20 transition-colors">
                  <Phone size={16} />
                </div>
                <span className="text-sm">{businessInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${businessInfo.email}`}
                className="flex items-center gap-3 text-white/80 hover:text-[#C5A572] transition-colors group"
              >
                <div className="bg-white/10 p-2 rounded-full group-hover:bg-[#C5A572]/20 transition-colors">
                  <Mail size={16} />
                </div>
                <span className="text-sm">{businessInfo.email}</span>
              </a>
            </div>

            <div className="mt-6">
              <h5 className="text-sm font-semibold text-[#C5A572] mb-3">Suivez-nous</h5>
              <div className="flex gap-3">
                <a
                  href={businessInfo.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 p-3 rounded-full hover:bg-[#C5A572] transition-all duration-300 hover:scale-110"
                >
                  <Facebook size={20} />
                </a>
                <a
                  href={businessInfo.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 p-3 rounded-full hover:bg-[#C5A572] transition-all duration-300 hover:scale-110"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/70">
            <p>
              © {currentYear} {businessInfo.name}. Tous droits réservés.
            </p>
            <p className="flex items-center gap-2">
              Fait avec <Heart size={16} className="text-[#C5A572] fill-current" /> pour le bien-être de vos animaux
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
